import { Badge, styled } from '@mui/material';
import { ActionButton } from 'src/components/ActionButton/ActionButton';
import { PageHeaderContainer } from 'src/components/PageHeader/PageHeaderContainer';
import { MOBILE_BREAKPOINT } from 'src/config-global';
import { pxToRem } from 'src/theme/typography';

export const ContainerStyled = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderLeft: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(2),
  },
}));

export const ActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'sticky',
  top: 0,
  alignItems: 'center',
  padding: theme.spacing(1.5, 0),
  gap: theme.spacing(2),
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    flexDirection: 'column',
  },
}));

export const ActionsSession = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 1.5),
  '&:not(.isGuest)': {
    display: 'none',
  },
  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    '&:not(.isGuest)': {
      display: 'flex',
    },
  },
}));

export const GatheringSession = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 1.5),

  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    '&:not(.isGuest)': {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.divider,
      borderStyle: 'solid',
      borderWidth: '1px 0',
      padding: theme.spacing(1.5),
    },
  },
}));

export const ActionsBarButtonStyled = styled(ActionButton)(({ theme }) => ({
  height: theme.spacing(4.5),
  width: theme.spacing(4.5),
  minWidth: 'unset',
  minHeight: 'unset',
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    height: theme.spacing(4.5),
    width: theme.spacing(4.5),
  },
}));

export const RightMenuContent = styled('div')(() => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  height: '100%',
}));

export const RightMenuHeader = styled(PageHeaderContainer)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.background.default}`,
}));

export const StyledListContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderTop: '1px solid transparent',
  width: '100%',
  gap: theme.spacing(2),
  '&.showBorder': {
    paddingTop: theme.spacing(2),
    borderColor: theme.palette.divider,
  },
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge ': {
    fontSize: pxToRem(10),
    padding: theme.spacing(0, 0.5),
  },
  '&:hover': {
    '& .icon': {
      opacity: 1,
    },
  },
}));

export const StyledTopLeftIcon = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(-0.75),
  left: theme.spacing(-0.75),
  width: theme.spacing(2.5),
  height: theme.spacing(2.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.spacing(4),
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.default,
  zIndex: 1,
  opacity: 0,
  '&:hover': {
    color: theme.palette.text.primary,
  },
  '&.pinned': {
    transform: 'rotate(315deg)',
  },
}));
